/** Réduit une photo de téléphone avant l'envoi.

Le grand côté passe à 1600 px au plus. Le fichier devient un JPEG à qualité
0.7. Le dessin sur un canvas neuf retire l'EXIF, donc la position GPS.
*/
export const PHOTO_MAX_SIDE = 1600;
export const PHOTO_QUALITY = 0.7;
export const PHOTO_TYPE = 'image/jpeg';
export const PHOTO_MAX_COUNT = 8;

export function fittedSize(width, height, maxSide = PHOTO_MAX_SIDE) {
  const w = Math.max(1, Number(width) || 1);
  const h = Math.max(1, Number(height) || 1);
  const longSide = Math.max(w, h);
  if (longSide <= maxSide) return { width: w, height: h };
  const scale = maxSide / longSide;
  return {
    width: Math.max(1, Math.round(w * scale)),
    height: Math.max(1, Math.round(h * scale)),
  };
}

export async function compressPhoto(file) {
  if (!file) throw new Error('Photo absente');
  const bitmap = await createImageBitmap(file);
  try {
    const { width, height } = fittedSize(bitmap.width, bitmap.height);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Compression impossible');
    context.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob((result) => {
        if (!result) reject(new Error('Compression impossible'));
        else resolve(result);
      }, PHOTO_TYPE, PHOTO_QUALITY);
    });
    return new File([blob], 'ronde.jpg', { type: PHOTO_TYPE, lastModified: Date.now() });
  } finally {
    if (typeof bitmap.close === 'function') bitmap.close();
  }
}
